import { AfterViewChecked, Component, HostListener, Inject, Injectable, OnDestroy, OnInit } from '@angular/core';
import { State, process } from '@progress/kendo-data-query';
import { Import, ImportFileData } from 'src/app/models/import';
import { GridDataResult, SelectableSettings } from '@progress/kendo-angular-grid';
import { DOCUMENT } from '@angular/common';
import {
  HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler,
  HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse
} from '@angular/common/http';
import { concat, Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { FileState, SuccessEvent, UploadEvent, UploadProgressEvent, SelectEvent } from '@progress/kendo-angular-upload';
import { Global } from 'src/app/shared/global.constants';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { LocalStoreManager } from 'src/app/shared/services/auth/local-store-manager.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { ImportService } from 'src/app/shared/services/payroll/import.service';

@Component({
  selector: 'app-payroll-reports',
  templateUrl: './payroll-reports.component.html',
  styleUrls: ['./payroll-reports.component.css']
})
export class PayrollReportsComponent implements OnInit, OnDestroy, AfterViewChecked {

  constructor(@Inject(DOCUMENT) private document: any,
    private importService: ImportService,
    private authService: AuthService,
    private localStorage: LocalStoreManager,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }
  imports: Import[];
  gridView: GridDataResult;
  importId: number;
  invoiceId: number;
  import: Import;
  config: any;
  grid: HTMLElement;
  selectedImport: Import;
  displayData: any = [];
  result: any[];
  extensionsBlacklist = [];
  continuePayrollMsg: any;
  ppedCloneValidationMsg: any;
  largeUploadMsg: any;
  submitImportMsg: any;
  deleteImportMsg: any;
  rowIndex = 0;
  take = 5;
  skip = 0;
  currentPage = 0;
  isSelectedRowChanged = false;
  isUnsubmittedImport = false;
  importDelete = false;
  cloneImportOpened = false;
  displayload = false;
  maxErrorExceeded = false;
  importOpened = false;
  disableClose = false;
  deleteRecordDialog = false;
  ppedExists = true;
  displaySubmit = false;
  disableSubmitBtn = true;
  continueImportId: any;
  selectedItem: any;
  uploadSaveUrl = '';
  currentOrgId = '';
  apiUrl = this.readConfigService.getApiUrl();
  uploadRemoveUrl = 'removeUrl';
  selectableSettings: SelectableSettings = { mode: 'single' };
  public pped: Date = new Date();
  currentFy = (this.pped.getFullYear() - (this.pped.getMonth() > 5 ? 0 : 1));
  minDate: Date = new Date(this.currentFy - 1, 6, 1);
  maxDate: Date = new Date(this.currentFy + 2, 5, 30);
  filterRows: any;
  ids: string;
  gridState: State = {
    sort: [],
    take: this.take,
    skip: 0,
  };
  validationSettings: any[];
  operators: any;
  disableSubmit: boolean;
  invalidPPED: boolean;
  isExtNotAllowed: boolean;
  fileExtName: any;
  scheduleSet: any;
  multplErrorMsg: any;
  defaultPaySchedule: any;
  currentCloneScrn = 1;
  file: any;

  @HostListener('window:load')
  unloadHandler() {
    setTimeout(() => {
      this.importService.deleteUnValidatedImports().subscribe(() => {
        this.LoadImports(this.getUserId(), this.authService.currentOrg);
      });
    }, 500);
  }

  ngOnInit() {
    this.authService.loggedInChecker(this.authService.isLoggedIn);
    this.loadValidationSettings();
    this.config = this.readConfigService.getPayrollUploadFile();
    this.continuePayrollMsg = this.config.ContinuePayrollMessage;
    this.ppedCloneValidationMsg = this.config.PPEDCloneValidation;
    this.largeUploadMsg = this.config.LargeUploadMessage;
    this.submitImportMsg = this.config.SubmitImportMsg;
    this.deleteImportMsg = this.config.DeleteImportMsg;
    this.operators = this.authService.getAccessOperations(2);
    this.authService.getMessage$().forEach(message => {
      if (this.localStorage.getData('CurrentComponent') === 'payroll') {
        this.LoadImports(this.getUserId(), message.text);
      }
    });
    this.extensionsBlacklist = this.config.ExtensionsBlacklist;
    this.LoadImports(this.getUserId(), this.authService.currentOrg);
  }

  ngOnDestroy(): void {
    this.localStorage.deleteData('CurrentComponent');
  }

  ngAfterViewChecked() {
    if (this.importOpened) {
      const popupClass = document.querySelectorAll('#create-import-dialog input');
      if (popupClass && popupClass.length > 0 && popupClass[0] as HTMLElement) {
        (popupClass[0] as HTMLElement).style.opacity = '0';
      }
    }
  }

  getSum(args: string): number {
    let totalSum = 0;
    this.displayData.map(x => {
      totalSum += x[args];
    });
    return totalSum;
  }

  loadValidationSettings() {
    this.importService.getValidationSettings()
      .subscribe(settings => {
        if (settings.statusCode === 200 && settings.result) {
          this.validationSettings = settings.result;
        }
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setErrorNotification();
        });
  }

  LoadImports(userId: number, orgId: number): void {
    this.notificationService.setUpLoading(true);
    this.currentCloneScrn = 1;
    this.uploadSaveUrl = this.apiUrl + Global.BASE_IMPORT_FROM_FILE_ENDPOINT;
    this.importService.getImports()
      .subscribe(imports => {
        if (imports.result.length > 0) {
          this.imports = imports.result;
          this.imports.forEach(element => {
            this.ids = element.id.toString();
            // tslint:disable-next-line: no-string-literal
            element['ids'] = this.ids;
            this.gridView = process(this.imports, this.gridState);
          });
          this.gridView = {
            data: imports.result.slice(0, this.take),
            total: imports.result.length
          };
          this.gridState.skip = 0;
          setTimeout(() => {
            this.rowIndex = 0;
            this.currentPage = 1;
            if (this.imports.length === 0) {
              this.isUnsubmittedImport = false;
            }
            this.SetSelectedRow(0, true, false, false);
          }, 100);
        } else {
          this.gridView = {
            data: imports.result.slice(0, this.take),
            total: imports.result.length
          };
          this.notificationService.setUpLoading(false);
          this.selectedImport = undefined;
          this.isUnsubmittedImport = false;
        }
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setUpLoading(false);
          this.notificationService.setErrorNotification();
        });
  }

  groupSummaryData(): void {
    const groups = new Set(this.displayData.map(item => item.locationCode));
    this.result = [];
    groups.forEach(g => {
      let contTotal = 0;
      let rcdCount = 0;
      const rcds = this.displayData.filter(i => i.locationCode === g);
      rcds.map(i => { contTotal += i.contribution; });
      rcds.map(i => { rcdCount += i.recordCount; });

      this.result.push({
        locationCode: g,
        values: rcds,
        contTotal,
        rcdCount
      });
    });
  }

  close() {
    this.importOpened = false;
    this.cloneImportOpened = false;
    this.multplErrorMsg = false;
    this.ppedExists = true;
    this.resetImportClone();
    this.file = null;
  }

  clone(id: number): void {
    this.importId = id;
    this.cloneImportOpened = true;
    this.pped = new Date();
    this.invalidPPED = true;
    this.resetImportClone();
  }

  onDateChange(e: any) {
    this.invalidPPED = (e !== null && (e.valueOf() > 0
      && e.valueOf() >= new Date(this.minDate.toDateString()).valueOf()));
  }

  resetImportClone() {
    this.defaultPaySchedule = null;
    this.currentCloneScrn = 1;
  }

  cloneImport(id: number): void {
    this.displayload = true;
    this.ppedExists = true;
    this.multplErrorMsg = false;
    const orgId = this.selectedImport.orgId;
    this.importService.isPpedExists(id, orgId, this.pped)
      .subscribe((response) => {
        this.ppedExists = response.result;
        this.submitCloning(id);
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.displayload = false;
          this.cloneImportOpened = false;
          this.notificationService.setErrorNotification();
        });
  }

  submitCloning(id: number) {
    if (this.ppedExists) {
      const payId = this.defaultPaySchedule ? this.defaultPaySchedule.id : 0;
      this.importService.cloneImport(id, this.pped, payId)
        .subscribe((response) => {
          this.defaultPaySchedule = null;
          if (response && response.scheduleSet) {
            const scheduleSet = response.scheduleSet;
            scheduleSet.forEach(x => { x.payDate = new Date(x.payDate).toLocaleDateString(); });
            this.defaultPaySchedule = { id: null, payDate: 'Select Pay Date...' };
            this.scheduleSet = scheduleSet;
            this.multplErrorMsg = response.message;
            this.currentCloneScrn = 2;
            this.displayload = false;
            return;
          }
          this.cloneImportOpened = false;
          this.displayResult(response);
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.displayload = false;
            this.cloneImportOpened = false;
            this.notificationService.setErrorNotification();
          });
    } else {
      this.displayload = false;
    }
  }

  ifCurrentComp() {
    this.localStorage.saveSyncedSessionData('payroll', 'CurrentComponent');
  }

  delete(id: number, invoiceId: number): void {
    this.importId = id;
    this.invoiceId = invoiceId;
    this.importDelete = true;
  }

  deleteImport(status: any): void {
    if (status === 'yes') {
      this.displayload = true;
      if (this.invoiceId === undefined) {
        this.invoiceId = 0;
      }
      this.deleteRecordDialog = true;
      this.importService.deleteImport(this.importId, this.invoiceId)
        .subscribe((response) => {
          setTimeout(() => {
            this.deleteRecordDialog = false;
          }, 100);
          this.importDelete = false;
          this.displayResult(response);
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.displayload = false;
            this.importDelete = false;
            this.deleteRecordDialog = false;
            this.notificationService.setErrorNotification();
          });
    } else {
      this.importDelete = false;
    }
  }

  openPopup() {
    this.multplErrorMsg = null;
    this.currentCloneScrn = 1;
    this.importOpened = true;
    this.isExtNotAllowed = false;
  }

  closePopup() {
    this.importOpened = false;
    this.multplErrorMsg = false;
  }

  onStateChange(state: State) {
    this.gridState = state;
    this.skip = state.skip === undefined ? 0 : state.skip;
    this.sortChange();
    setTimeout(() => {
      this.rowIndex = 0;
      this.SetSelectedRow(0, true, false, false);
    }, 300);
  }

  sortChange(): void {
    const sorting = this.assignArray(this.gridState.sort);
    sorting.forEach(element => {
      if (element.field === 'pped') {
        element.field = 'payPeriodEndDate';
      }
    });
    this.gridView = process(this.imports, { ...this.gridState, sort: sorting });
  }

  assignArray(source: any[]) {
    const dest = [];
    source.forEach((v: any) => {
      const val = (typeof v === 'object') ? Object.assign({}, v) : v;
      dest.push(val);
    });
    return dest;
  }

  onSelect(selectedimport: Import): void {
    this.selectedImport = selectedimport;
  }

  cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }: any) {
    if (!isEdited) {
      this.notificationService.setUpLoading(true);
      this.selectedImport = dataItem;
      this.isUnsubmittedImport = dataItem.submitted === null;
      this.notificationService.setUpLoading(false);
    }
    if (this.selectedItem !== dataItem) {
      this.notificationService.setUpLoading(true);
      this.isSelectedRowChanged = true;
      this.selectedItem = dataItem;
    } else {
      this.isSelectedRowChanged = false;
    }
  }

  onRecordChange(data: any) {
    this.LoadImports(this.getUserId(), this.authService.currentOrg);
    this.displayload = false;
  }

  getUserId(): number {
    return this.authService.userId;
  }

  isImportProcessed(dataItem): boolean {
    return (dataItem.paymentStatus < 1 || dataItem.submitted == null);
  }

  uploadProgressEventHandler(e: UploadProgressEvent) {
    this.disableClose = true;
  }

  importError(isError: boolean) {
    this.disableSubmitBtn = isError;
  }

  onFileSubmit() {
    this.disableSubmit = true;
    this.displayload = true;
    this.multplErrorMsg = false;
    const payId = this.defaultPaySchedule ? this.defaultPaySchedule.id : 0;
    this.importService.uploadImportFile(this.importService.getFileUpload(), payId).subscribe((response: any) => {
      if (response && response.success) {
        this.resetImportClone();
      }
      this.importOpened = false;
      this.disableSubmit = false;
      this.displayload = false;
      this.displayResult(response);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.importOpened = false;
        this.disableSubmit = false;
        this.displayload = false;
        this.notificationService.setErrorNotification();
      });
  }

  uploadSuccess(e: SuccessEvent) {
    if (e.response !== null && e.response.body && !e.response.body.success && e.response.body.import === undefined) {
      const response = e.response.body;
      this.defaultPaySchedule = null;
      if (response && response.scheduleSet) {
        this.file = e.files;
        this.importService.saveFileUpload(e.files);
        const scheduleSet = response.scheduleSet;
        scheduleSet.forEach(x => { x.payDate = new Date(x.payDate).toLocaleDateString(); });
        this.defaultPaySchedule = { id: null, payDate: 'Select Pay Date...' };
        this.scheduleSet = scheduleSet;
        this.currentCloneScrn = 2;
        this.importOpened = true;
        this.disableClose = false;
        this.multplErrorMsg = response.message;
        return;
      }
      this.displayResult(response);
    } else if (e.response !== null && !e.response.body.success) {
      this.maxErrorExceeded = true;
      this.continueImportId = e.response.body.import;
    } else if (e.response !== null && e.response.body.success) {
      this.displayResult(e.response.body);
    }
    this.disableClose = false;
    this.closePopup();
  }

  continueUpload(action: any) {
    if (action === 'yes') {
      this.displayload = true;
      const id = this.continueImportId;
      this.closePopup();
      this.importService.continueUpload(id)
        .subscribe(response => {
          this.maxErrorExceeded = false;
          this.displayResult(response);
          this.uploadComplete(response);
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.displayload = false;
            this.maxErrorExceeded = false;
            this.notificationService.setErrorNotification();
          });
    } else {
      this.importId = this.continueImportId;
      this.deleteImport('yes');
      this.closePopup();
      this.maxErrorExceeded = false;
    }
  }

  uploadComplete(obj: any) {
    if (!this.maxErrorExceeded && !this.importOpened) {
      this.LoadImports(this.getUserId(), this.authService.currentOrg);
    }
  }

  displaySubmitPop(): void {
    this.notificationService.setUpLoading(true);
    this.importService.getPreSubmitData(this.selectedImport.id.toString())
      .subscribe(response => {
        this.displayData = response;
        this.notificationService.setUpLoading(false);
        this.displaySubmit = true;
        this.groupSummaryData();
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.displaySubmit = false;
        this.notificationService.setErrorNotification();
      });
  }

  submitImport(args: string) {
    if (args === 'yes') {
      this.displayload = true;
      this.importService.submitImport(this.selectedImport.id)
        .subscribe((response) => {
          this.displaySubmit = false;
          this.displayResult(response);
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.displayload = false;
            this.displaySubmit = false;
            this.notificationService.setErrorNotification();
          });
    } else {
      this.displaySubmit = false;
    }
  }

  displayResult(response: any) {
    this.notificationService.setUpNotification(response, false);
    if (response.success) {
      this.LoadImports(this.getUserId(), this.authService.currentOrg);
    }
    this.displayload = false;
  }

  onFileSelect(ev: SelectEvent) {
    if (ev) {
      this.fileExtName = ev.files[0].extension;
      const removeDot = this.fileExtName.substring(1).toUpperCase();
      this.isExtNotAllowed = this.extensionsBlacklist.some(x => x === removeDot);
      if (this.isExtNotAllowed) {
        ev.preventDefault();
      }
    }
  }

  remove(upload: any, uid: string) {
    upload.removeFilesByUid(uid);
  }

  showButton(state: FileState): boolean {
    return (state === FileState.Uploaded);
  }

  uploadEventHandler(req: UploadEvent) {
    const data = new ImportFileData();
    data.userInfo = JSON.stringify(this.importService.UserInfo());
    req.data = data;
    const token = sessionStorage.getItem('access_token');
    req.headers = req.headers.append('Authorization', 'Bearer ' + token);
  }

  SetSelectedRow(index: number, isManualSelection: any, isSelected: any, isCellClick: any) {
    if (this.document === null) { return; }
    const importElem = this.document.getElementById('importsGrid');
    if (importElem === null) { return; }
    const grid = importElem.getElementsByClassName('k-grid-content')[0];
    if (grid === null) { return; }
    const filterRow = importElem.getElementsByClassName('k-filter-row');
    if (filterRow !== null && filterRow[0] !== null) {
      const inputRows = filterRow[0].getElementsByTagName('input');
      if (inputRows !== null) {
        this.filterRows = inputRows;
      }
    }
    const rows = grid.getElementsByTagName('tr');

    let dataRowIndex = -1;
    const selectedRow = grid.getElementsByClassName('k-state-selected')[0];

    for (const row of rows) {
      if (row.className.indexOf('k-grouping-row') < 0 && row.className.indexOf('k-group-footer') < 0) {

        if (isManualSelection) {
          this.rowIndex = 1;

          if (selectedRow != null) {
            selectedRow.className = String(selectedRow.className)
              .replace(' k-state-selected', '')
              .replace('k-state-selected', '');
          }
          for (const childRow of row.children) {
            if (childRow.className.indexOf('k-group-cell') < 0 && childRow.children[0] != null) {
              row.children[0].click();
              break;
            }
          }
          break;
        } else {
          if (this.isSelectedRowChanged) {
            this.rowIndex = index + 1;
            return;
          }
          if (selectedRow == null) {
            row.className = row.className + ' k-state-selected';
            for (const childRow of row.children) {
              if (childRow.className.indexOf('k-group-cell') < 0 && childRow.children[0] != null) {
                childRow.click();
                break;
              }
            }
            break;
          } else {
            dataRowIndex++;
            if (!this.isSelectedRowChanged) {
              break;
            } else {
              this.rowIndex = dataRowIndex + 1;
            }
          }
        }
      }
    }
  }

}

@Injectable()
export class UploadInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url === 'saveUrl') {
      const events: Observable<HttpEvent<any>>[] = [0, 30, 60, 100].map((x) => of({
        type: HttpEventType.UploadProgress,
        loaded: x,
        total: 100
      } as HttpProgressEvent).pipe(delay(1000)));
      const success = of(new HttpResponse({ status: 200 })).pipe(delay(1000));
      events.push(success);

      return concat(...events);
    }

    if (req.url === 'removeUrl') {
      return of(new HttpResponse({ status: 200 }));
    }

    return next.handle(req);
  }
}
